import { datadogLogs } from "@datadog/browser-logs";

const logger = datadogLogs.logger;

export default logger;
